export default "__VITE_ASSET__mfe6DZfm__"